module.exports = __webpack_public_path__ + "static/media/preview-photogallery.a13260bf.png";